import './assets/style/main.css'

import { createApp } from 'vue'
import createI18nPlugin from '@/utils/i18n'
import { logAuthEvent } from '@/services/debug/authDebug'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(router)

// Install auth plugin only in development mode
// import {install as installAuthPlugin} from "@/services/auth/Plugin";

const startApp = async () => {
  logAuthEvent('auth.app.bootstrap.started')

  // if (import.meta.env.MODE === 'development') await installAuthPlugin(app)

  const I18n = await createI18nPlugin()
  await app.use(I18n)
  app.mount('#app')

  logAuthEvent('auth.app.bootstrap.completed')
}

startApp().catch((error) => {
  logAuthEvent(
    'auth.app.bootstrap.failed',
    {
      error
    },
    'error'
  )

  throw error
})
